/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TypeCell/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Adjustment from './Adjustment/index'
import AppliedPayment from './AppliedPayment/index'
import Charge from './Charge/index'
import ChargeTransfer from './ChargeTransfer/index'
import InstallmentCharge from './InstallmentCharge/index'
import No from './No/index'
import Note from './Note/index'
import Payment from './Payment/index'
import PaymentCorrection from './PaymentCorrection/index'
import PaymentPlan from './PaymentPlan/index'
import PaymentPlanRollback from './PaymentPlanRollback/index'
import React from 'react'
import Refund from './Refund/index'
import TransferCharge from './TransferCharge/index'
import TransferCredit from './TransferCredit/index'
import UnappliedPayment from './UnappliedPayment/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TypeCell({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/TypeCell"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let entryTypeValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: entryTypeValueData,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="TypeCell.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-ZId5dh': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Adjustment'}>
<Adjustment
  viewPath={`${viewPath}/Adjustment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Charge'}>
<Charge
  viewPath={`${viewPath}/Charge`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InstallmentCharge'}>
<InstallmentCharge
  viewPath={`${viewPath}/InstallmentCharge`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TransferCharge'}>
<TransferCharge
  viewPath={`${viewPath}/TransferCharge`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ChargeTransfer'}>
<ChargeTransfer
  viewPath={`${viewPath}/ChargeTransfer`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentPlan'}>
<PaymentPlan
  viewPath={`${viewPath}/PaymentPlan`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentPlanRollback'}>
<PaymentPlanRollback
  viewPath={`${viewPath}/PaymentPlanRollback`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Payment'}>
<Payment
  viewPath={`${viewPath}/Payment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentCorrection'}>
<PaymentCorrection
  viewPath={`${viewPath}/PaymentCorrection`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AppliedPayment'}>
<AppliedPayment
  viewPath={`${viewPath}/AppliedPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'UnappliedPayment'}>
<UnappliedPayment
  viewPath={`${viewPath}/UnappliedPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Refund'}>
<Refund
  viewPath={`${viewPath}/Refund`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TransferCredit'}>
<TransferCredit
  viewPath={`${viewPath}/TransferCredit`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Note'}>
<Note
  viewPath={`${viewPath}/Note`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}